export default [
	{
		path: '/:pathMatch(.*)*',
		name: '404',
		hidden:true,
		component: () => import('@/views/404.vue'),
		meta: {
			icon:'Warning',
			title: 'message.fail',
		},
	},
]